import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import useData from "../hooks/useData"; // Adjust the path as needed
import { storage } from "../../../../config/firebase"; // Adjust the path as needed
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const SchoolLogo = ({ open, onClose, school, onUpdate }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { updateSchoolLogo } = useData();

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (
      selectedFile &&
      (selectedFile.type === "image/png" || selectedFile.type === "image/jpeg")
    ) {
      setFile(selectedFile);
      setError("");
    } else {
      setError("Please select a valid image file (PNG or JPEG).");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError("Please select a file to upload.");
      return;
    }

    setLoading(true);
    try {
      console.log("Uploading file to Firebase Storage...");
      const storageRef = ref(storage, `school_logos/${file.name}`);
      await uploadBytes(storageRef, file);
      console.log("File uploaded successfully. Getting download URL...");
      const downloadURL = await getDownloadURL(storageRef);
      console.log("Download URL obtained:", downloadURL);

      const schoolInfo = {
        school_id: school.school_id,
        school_logo: downloadURL,
      };

      const schoolInfoData = {
        jsStruct: JSON.stringify(schoolInfo),
      };

      console.log("Updating school logo in the database...");
      await updateSchoolLogo(school.school_id, schoolInfoData);
      console.log("School logo updated successfully in the database.");
      onUpdate({ ...school, school_logo: downloadURL });
      onClose();
    } catch (error) {
      console.error("Error uploading file:", error);
      setError("Error uploading file. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <ModalDialogTitle onClose={onClose}>Update School Logo</ModalDialogTitle>
      <DialogContent>
        <input
          type="file"
          accept="image/png, image/jpeg"
          onChange={handleFileChange}
        />
        {error && <Alert severity="error">{error}</Alert>}
        {loading && (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress />
          </Box>
        )}
      </DialogContent>
      <ModalActions onSave={handleSubmit} saving={loading} saveLabel="Submit" />
    </Dialog>
  );
};

export default SchoolLogo;
